import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        // component: () => import('../views/KyouikuInput')
        name: 'Period',
        meta: {
            title: '募集は終了しました。',
        },
        component: () => import('../views/KyouikuInputPeriod')
    },
    {
        path: '/inputdone',
        name: 'Done',
        meta: {
            title: '申し込み完了しました。',
        },
        component: () => import('../views/KyouikuInputDone')
    },
    {
        path: '/inputp',
        name: 'Period',
        meta: {
            title: '募集は終了しました。',
        },
        component: () => import('../views/KyouikuInputPeriod')
    },
    {
        path: '/inputerror',
        name: 'Error',
        meta: {
            title: 'エラーが発生しました。',
        },
        component: () => import('../views/KyouikuInputError')
    }
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

export default router